<template>
    <div>
        <md-dialog :md-active.sync="show" class="filter-dialog">
        <md-dialog-title>Add Filters</md-dialog-title>
        <md-dialog-content>

            <multiselect v-model="selectedFilterCustomers" class="searchCustomer"
                id="searchCustomer" 
                label="title_th"
                track-by="code" 
                placeholder="Type to search customer." 
                open-direction="bottom" 
                :options="dataSearchCustomers" 
                :multiple="true" 
                :searchable="true" 
                :loading="isLoadingCustomer" 
                :internal-search="false" 
                :clear-on-select="false" 
                :close-on-select="false" 
                :options-limit="300" 
                :max-height="600" 
                :show-no-results="true" 
                :hide-selected="true"
                :showLabels="false"
                @search-change="asyncFindCustomers"
                style="z-index:100;margin-bottom:20px;"
            >
                <template slot="singleLabel" slot-scope="{ props }">
                    <strong>{{ props.option.language  }}</strong>
                </template>
                <span slot="noResult">Not found products.</span>
            </multiselect>

            <multiselect v-model="selectedFilterProducts" class="searchProduct"
                id="searchProduct" 
                label="title_th"
                track-by="code" 
                placeholder="Type to search products." 
                open-direction="bottom" 
                :options="dataSearchProducts" 
                :multiple="true" 
                :searchable="true" 
                :loading="isLoadingProduct" 
                :internal-search="false" 
                :clear-on-select="false" 
                :close-on-select="false" 
                :options-limit="300" 
                :max-height="600" 
                :show-no-results="true" 
                :hide-selected="true"
                :showLabels="false"
                @search-change="asyncFindProducts"
                style="z-index:90;"
            >
                <template slot="singleLabel" slot-scope="{ props }">
                    <strong>{{ props.option.language  }}</strong>
                </template>
                <span slot="noResult">Not found products.</span>
            </multiselect>



        </md-dialog-content>



        <md-dialog-actions>
            <md-button @click="cancelFilter()" class="md-cancel">cancel</md-button>
            <md-button class="md-primary" @click="addFilter()">add filter</md-button>
        </md-dialog-actions>
        </md-dialog>
    </div>
</template>

<script>
import CustomerService from '@/services/customer'
import ProductService from '@/services/product'

export default {
    name: "dlgFilter",
    props: ["show"],
    data(){
        return {
            isLoadingCustomer: false,
            isLoadingProduct: false,

            selectedFilterCustomers: null,
            dataSearchProducts: [],

            selectedFilterProducts:null,
            dataSearchCustomers: []
        }
    },
    methods:{
        asyncFindProducts(query) {
            this.isLoadingProduct = true;
            ProductService.search(query).then(response => {
                this.dataSearchProducts = response;
                this.isLoadingProduct = false;
            });
        },
        asyncFindCustomers(query) {
            this.isLoadingCustomer = true;
            CustomerService.search(query).then(response => {
                this.dataSearchCustomers = response;
                this.isLoadingCustomer = false;
            });
        },        
        cancelFilter(){
            this.$emit('cancel', false)
        }
    }
}
</script>

<style lang="scss" scoped>
.searchCustomer{
    margin-bottom: 20px;
}
.searchProduct{
    margin-bottom: 20px;
}
.multiselect--active {
  z-index: 10 !important;
}
</style>
